import { ensureClaimCorn } from '@eigtech/shared-corn-helper'
import { useGetAssignmentsForAssignable } from '@eigtech/ui-shared-assignments'

export function useGetAssignmentsForClaim(claimNumber: string) {
  return useGetAssignmentsForAssignable(ensureClaimCorn(claimNumber))
}
